import { NoSSR } from '@/components';
import { getDefaultStaticProps } from '@/utils';
import { QuoteResultPageView } from './QuoteResultPageView';
const QuoteResultPage = () => <NoSSR data-sentry-element="NoSSR" data-sentry-component="QuoteResultPage" data-sentry-source-file="index.page.tsx">
    <QuoteResultPageView data-sentry-element="QuoteResultPageView" data-sentry-source-file="index.page.tsx" />
  </NoSSR>;
export const getStaticProps = getDefaultStaticProps;
export default QuoteResultPage;